import { useGetListByOrg } from './useGetList'

export const systemIds = {
  getListByOrg: useGetListByOrg,
}
